// extracted by mini-css-extract-plugin
export var gradient = "EntriesBlock-module--gradient--f4ba5";